import { render, staticRenderFns } from "./editUserBlack.vue?vue&type=template&id=cf76cdb6&scoped=true&"
import script from "./editUserBlack.vue?vue&type=script&lang=js&"
export * from "./editUserBlack.vue?vue&type=script&lang=js&"
import style0 from "./editUserBlack.vue?vue&type=style&index=0&id=cf76cdb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf76cdb6",
  null
  
)

export default component.exports